import { AbstractControl, ValidationErrors, ValidatorFn, FormGroup } from '@angular/forms';

/**
 * Custom validator factory function that checks if at least one of the specified fields in a FormGroup has a value.
 * @param fieldNames - An array of strings representing the names of the fields to check.
 * @returns A ValidatorFn that performs the validation.
 */
export const oneOfFieldsRequiredValidator = (fieldNames: string[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const group = control as FormGroup;

    // Check if at least one of the specified fields has a value
    const hasValue = fieldNames.some((fieldName) => {
      const fieldControl = group.controls[fieldName];
      return fieldControl && fieldControl.value;
    });

    // If none of the fields have a value, return an error
    if (!hasValue) {
      // Using a generic error key, can be customized if needed
      return { oneOfFieldsRequired: { requiredFields: fieldNames } };
    }

    // If at least one has a value, validation passes
    return null;
  };
};
